<template>
  <div id="sidemenu" class="flex-shrink-0">
    <router-link :to="{ name: 'home' }" data-cy="sidemenu-logo">
      <div class="logo">
        <img src="@/assets/svg/Icon_Gradient.svg" />
      </div>
    </router-link>
    <router-link
      :to="{ name: 'home' }"
      exact
      tag="div"
      class="area-button"
      data-cy="sidemenu-templates"
      ref="homebutton"
    >
      <i class="fa-light fa-file home-area-icon"></i>
      <span class="router-desc">{{ $t("sidemenu.templates") }}</span>
    </router-link>

    <router-link
      :to="{ name: 'data' }"
      exact
      tag="div"
      class="area-button"
      data-cy="sidemenu-integrations"
      ref="databutton"
    >
      <i class="fa-light fa-database data-area-icon"></i>
      <span class="router-desc">{{ $t("sidemenu.data") }}</span>
    </router-link>

    <router-link :to="{ name: 'settings' }" tag="div" class="area-button" data-cy="sidemenu-settings">
      <i class="fa-light fa-cog settings-area-icon"></i>
      <span class="router-desc">{{ $t("sidemenu.settings") }}</span>
    </router-link>

    <div class="area-button logout-btn" @click="logOut" data-cy="sidemenu-logout">
      <i class="fa-light fa-sign-out"></i>
      <span class="router-desc">{{ $t("sidemenu.signout") }}</span>
    </div>

    <div class="documentation">
      <a href="https://help.icrobotics.com/" target="_blank">
        <i class="fa-light fa-circle-info"></i>
      </a>
    </div>
  </div>
</template>

<script>
import ConfirmModal from "@/components/modals/ConfirmModal";
export default {
  name: "sidemenu",
  data() {
    return {
      test: "test"
    };
  },
  methods: {
    logOut() {
      this.$modal.show(
        ConfirmModal,
        {
          title: this.$t("logout.title"),
          description: this.$t("logout.desc"),
          confirmButtonText: this.$t("logout.confirm"),
          onConfirm: (result) => {
            this.$store.dispatch("logOut").then(() => {
              this.$router.push("login");
              location.reload();
            });
          }
        },
        { width: 350, height: "auto", adaptive: true }
      );
    },

    handleDemoGuide(){
      const demoPopupPlacement = this.$refs.databutton.$el.getBoundingClientRect();
      this.$store.commit("addPositionToDemoGuide", {
        step: 1,
        x: demoPopupPlacement.right,
        y: demoPopupPlacement.y,
        placement: "right"
      });
      const demoPopupPlacementHome = this.$refs.homebutton.$el.getBoundingClientRect();
      this.$store.commit("addPositionToDemoGuide", {
        step: 3,
        x: demoPopupPlacementHome.right,
        y: demoPopupPlacementHome.y,
        placement: "right"
      });
    }
  },
  computed:{
    postDemoGuide(){
      return this.$store.state.postDemoGuide
    }
  },
  watch:{
  postDemoGuide:{
    handler: function () {
      if (this.postDemoGuide == true) {
        this.handleDemoGuide()
      }
    }, immediate: true
  }
  },
  mounted() {
  },
  components: {}
};
</script>

<style lang="less">
#sidemenu {
  position: relative;
  z-index: 2;
  box-shadow: 2px 2px 4px 0 rgba(89, 102, 107, 0.4);
  width: 85px;
  background-color: var(--charcoal);
  .logo {
    padding: 31px 0 51px 0;
    text-align: center;
    img {
      width: 35px;
    }
  }

  .area-button {
    position: relative;
    cursor: pointer;
    height: 83px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #485258;
    border-right: none;
    border-left: none;
    &.router-link-active {
      border-left: 2px solid var(--flame);
      svg {
        color: var(--flame);
      }
    }
    .router-desc {
      display: none;
      position: absolute;
      top: 58px;
      font-size: 12px;
      color: var(--alabaster);
    }

    svg {
      color: var(--alabaster);
      font-size: 26px;
    }

    &:hover > .router-desc {
      display: block;
    }

    .temp-icon {
      width: 22px;
    }
    .logout {
      width: 22px;
    }
  }

  .documentation {
    position: absolute;
    height: 85px;
    bottom: 0px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    p {
      opacity: 0.8;
      color: var(--alabaster);
      border: 2px solid var(--alabaster);
      padding: 1px 10px;
      border-radius: 50% 50%;
      font-weight: bold;
    }

    svg {
      font-size: 24px;
      color: #fff;
    }
  }
}

</style>
